import { Mail } from 'lucide-react';
import { EMAIL, useLanguage } from '../i18n/content';
import { LangSwitch } from './LangSwitch';

const SECTION_IDS = ['beranda', 'tentang', 'layanan', 'kontak'];

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/5 bg-[#070709]">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8 lg:px-10 lg:py-12">
        <div className="grid gap-10 md:grid-cols-2 md:gap-8 md:items-start min-[1200px]:grid-cols-12">
          <div className="md:col-span-1 min-[1200px]:col-span-5">
            <a href="#beranda" data-testid="footer-logo" aria-label="NOFINA">
              <img
                src="/nofina-logo.webp"
                alt="NOFINA"
                width="2000"
                height="667"
                className="h-auto w-[180px] lg:w-[250px]"
              />
            </a>
            <p className="mt-5 text-sm tracking-[0.18em] text-slate-400">
              {t.footer.line}
            </p>
          </div>

          <div className="md:col-span-1 min-[1200px]:col-span-3">
            <h3 className="font-display text-sm font-bold uppercase tracking-widest text-white">
              {t.footer.navTitle}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {SECTION_IDS.map((id) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    data-testid={`footer-nav-${id}`}
                    className="text-sm text-slate-400 transition-colors hover:text-white"
                  >
                    {t.nav[id]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-1 min-[1200px]:col-span-2">
            <h3 className="font-display text-sm font-bold uppercase tracking-widest text-white">
              {t.footer.contactTitle}
            </h3>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="mt-4 inline-flex items-center gap-2 text-sm text-slate-400 transition-colors hover:text-white"
            >
              <Mail className="h-4 w-4 shrink-0 text-nofina-red" />
              {EMAIL}
            </a>
          </div>

          <div className="md:col-span-1 min-[1200px]:col-span-2">
            <h3 className="font-display text-sm font-bold uppercase tracking-widest text-white">
              {t.footer.langTitle}
            </h3>
            <LangSwitch testIdPrefix="footer-lang" className="mt-4" />
          </div>
        </div>

        <div className="mt-10 border-t border-white/5 pt-5">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
